<div
  class="foto-popup-overlay"
  *ngIf="fotoPopupAberta"
  role="dialog"
  aria-modal="true"
  aria-label="Foto do catequizando"
  (click)="fecharFotoPopup()"
>
  <div class="foto-popup-panel" (click)="$event.stopPropagation()">
    <div class="foto-popup-header">
      <span class="foto-popup-titulo">{{ fotoPopupTitulo }}</span>
      <button
        type="button"
        nbButton
        ghost
        size="small"
        class="foto-popup-fechar"
        aria-label="Fechar"
        (click)="fecharFotoPopup()"
      >
        ×
      </button>
    </div>
    <div class="foto-popup-body">
      <img
        *ngIf="fotoPopupUrl"
        class="foto-popup-imagem"
        [src]="fotoPopupUrl"
        alt="Foto do catequizando"
        (error)="onFotoPopupErro()"
      />
    </div>
  </div>
</div>

<nb-card class="dialog-card">
  <nb-card-header>Cadastro de Pessoa</nb-card-header>
  <nb-card-body>
    <form id="formPessoa" #formPessoa="ngForm" (ngSubmit)="salvar()">
      <div class="dialog-field-grid">
        <div class="field-block full-row foto-bloco-cadastro" *ngIf="pessoa.id">
          <span class="label-foto-cadastro">Foto</span>
          <div class="foto-acoes-cadastro">
            <button
              *ngIf="temFotoRegistrada()"
              type="button"
              nbButton
              size="small"
              status="success"
              appearance="outline"
              (click)="verFoto()"
            >
              Ver foto
            </button>
            <button
              *ngIf="temFotoRegistrada()"
              type="button"
              nbButton
              size="small"
              status="danger"
              appearance="outline"
              [disabled]="apagandoFoto"
              (click)="confirmarApagarFoto()"
            >
              {{ apagandoFoto ? 'Removendo…' : 'Apagar foto' }}
            </button>
            <span *ngIf="!temFotoRegistrada()" class="foto-sem-cadastro-msg">Nenhuma foto cadastrada.</span>
          </div>
        </div>
        <!-- FRM-07: o documento é o primeiro campo, e é por ele que se descobre duplicata. -->
        <div class="field-block full-row">
          <label for="cpf">CPF *</label>
          <div class="field-with-badge">
            <input
              nbInput
              fullWidth
              id="cpf" required
              placeholder="000.000.000-00"
              [mask]="mascaras.cpf"
              [(ngModel)]="pessoa.cpf"
              name="cpf"
              [attr.autofocus]="pessoa.id ? null : ''"
              [attr.aria-invalid]="cpfInvalido"
              (blur)="aoInformarCpf()"
            />
            <button
              type="button"
              class="theos-diff-badge"
              *ngIf="rotuloBadgeTheosCpf() as bc"
              [title]="'Clique para copiar o valor do Theos para o campo — ' + bc"
              (click)="aplicarValorTheos('cpf')"
            >
              Theos: {{ bc }}
            </button>
          </div>
          <p class="campo-erro" *ngIf="cpfInvalido">CPF inválido: confira os dígitos.</p>
          <p class="campo-aviso" *ngIf="verificandoCpf">Conferindo se este CPF já está cadastrado…</p>
          <p class="campo-aviso" *ngIf="avisoCpf">{{ avisoCpf }}</p>
        </div>
        <div class="field-block full-row">
          <label for="nome">Nome *</label>
          <div class="field-with-badge">
            <input nbInput fullWidth id="nome" required placeholder="Digite o nome" [(ngModel)]="pessoa.nome" name="nome" />
            <button
              type="button"
              class="theos-diff-badge"
              *ngIf="rotuloBadgeTheosNome() as bn"
              [title]="'Clique para copiar o valor do Theos para o campo — ' + bn"
              (click)="aplicarValorTheos('nome')"
            >
              Theos: {{ bn }}
            </button>
          </div>
        </div>
        <div class="field-block">
          <label for="dataNascimento">Data de Nascimento *</label>
          <div class="field-with-badge">
            <input
              nbInput
              fullWidth
              id="dataNascimento" required
              placeholder="dd/MM/aaaa"
              [mask]="mascaras.data"
              [dropSpecialCharacters]="false"
              [(ngModel)]="dataNascimentoBr"
              (ngModelChange)="onDataNascimentoBrChange()"
              name="dataNascimento"
            />
            <button
              type="button"
              class="theos-diff-badge"
              *ngIf="rotuloBadgeTheosDataBr() as bdd"
              [title]="'Clique para copiar a data do Theos (dd/MM/aaaa) para o campo'"
              (click)="aplicarValorTheos('dataNascimento')"
            >
              Theos: {{ bdd }}
            </button>
          </div>
        </div>
        <div class="field-block full-row">
          <label for="sexo">Sexo *</label>
          <div class="field-with-badge field-with-badge--select">
            <nb-select id="sexo" required placeholder="Selecione o sexo" fullWidth [(selected)]="pessoa.sexo" name="sexo">
              <nb-option value="M">Masculino</nb-option>
              <nb-option value="F">Feminino</nb-option>
            </nb-select>
            <button
              type="button"
              class="theos-diff-badge"
              *ngIf="rotuloBadgeTheosSexo() as bs"
              [title]="'Clique para copiar o valor do Theos para o campo — ' + labelSexoBadge(bs)"
              (click)="aplicarValorTheos('sexo')"
            >
              Theos: {{ labelSexoBadge(bs) }}
            </button>
          </div>
        </div>
        <div class="field-block">
          <label for="telefone">Telefone</label>
          <input
            nbInput
            fullWidth
            id="telefone"
            placeholder="(00) 00000-0000"
            [mask]="mascaras.telefone"
            [dropSpecialCharacters]="false"
            [(ngModel)]="pessoa.telefone"
            name="telefone"
          />
        </div>
        <div class="field-block">
          <label for="email">Email</label>
          <div class="field-with-badge">
            <input nbInput fullWidth id="email" placeholder="Digite o email" [(ngModel)]="pessoa.email" name="email" />
            <button
              type="button"
              class="theos-diff-badge"
              *ngIf="rotuloBadgeTheosEmail() as be"
              [title]="'Clique para copiar o valor do Theos para o campo — ' + be"
              (click)="aplicarValorTheos('email')"
            >
              Theos: {{ be }}
            </button>
          </div>
        </div>
      </div>
      <p class="hint-sem-theos" *ngIf="pessoa.id && pessoaDetalheCarregada && !podeEnviarTheos()">
        Esta pessoa não possui código Theos numérico no cadastro local. Sem esse vínculo não é possível comparar nem
        enviar dados ao Theos.
      </p>
    </form>
  </nb-card-body>
  <nb-card-footer class="footer-actions">
    <div class="footer-actions-left" *ngIf="podeEnviarTheos()">
      <button
        nbButton
        status="warning"
        type="button"
        size="medium"
        [disabled]="enviandoTheos"
        (click)="enviarParaTheos()"
        title="Salva o cadastro local e, em seguida, envia nome, CPF, sexo, data de nascimento, contatos etc. ao Theos"
      >
        {{ enviandoTheos ? 'Enviando ao Theos…' : 'Enviar ao Theos' }}
      </button>
      <span class="hint-theos-comparacao" *ngIf="carregandoComparacaoTheos">Consultando Theos…</span>
    </div>
    <div class="footer-actions-right">
      <button nbButton status="basic" type="button" size="medium" (click)="fechar()">Cancelar</button>
      <button nbButton status="primary" type="submit" size="medium" form="formPessoa">Salvar</button>
    </div>
  </nb-card-footer>
</nb-card>
